import { render } from "./DelivryCompanyDetails.vue?vue&type=template&id=2ae613f6&scoped=true"
import script from "./DelivryCompanyDetails.vue?vue&type=script&lang=js"
export * from "./DelivryCompanyDetails.vue?vue&type=script&lang=js"

import "./DelivryCompanyDetails.vue?vue&type=style&index=0&id=2ae613f6&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae613f6"]])

export default __exports__